import { cn } from '@/shared/utils';
import type { ComponentType, ReactNode, SVGProps } from 'react';

interface Props {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  children?: ReactNode;
  className?: string;
}

export const ActionMenuItemContent = ({
  icon: Icon,
  label,
  children,
  className,
}: Props) => (
  <div className={cn('flex items-center gap-[1.6rem] w-full', className)}>
    {Icon && (
      <div className="w-[2.4rem] h-[2.4rem] flex items-center justify-center">
        <Icon className="size-[2.4rem] text-primary" />
      </div>
    )}

    <span className="headline4 text-primary flex-1">{label}</span>

    {children}
  </div>
);
